module.exports = __webpack_public_path__ + "img/security-audit-img-2.200f4dcd.webp";